// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { fetchUsers } from 'helpers/api'
import { settingsFailedToLoadMessage } from 'redux/modules/notifications/helpers'

const getThemUsers = () => dispatch => (
  dispatch(loadingToggler(
    async () => {
      try {
        const { entities } = await fetchUsers()
        return entities
      } catch (err) {
        console.warn(err)
        dispatch(settingsFailedToLoadMessage('User', err))
        // return an empty array so we can gracefully handle
        return []
      }
    })
  )
)

export default getThemUsers
